import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { EditCustomerPage } from '../../../../features/customers/customer-edit-pages'
import { customerGroupsQueryOptions } from '../../../../features/customers/queries'

export const Route = createFileRoute('/_app/customers/$customerId/edit')({
  staticData: { crumb: 'customerEdit' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'customers.update'),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(customerGroupsQueryOptions)
  },
  component: EditCustomerPage,
})
